<template>
  <b-modal id="modal-precheckindatacollector" centered @shown="show" @hidden="reset" @ok="confirm">
    <template slot="modal-header">
      <h1 class="modal-title"> {{ $t('modal_pre_checkin_data_collector.title') }}</h1>
      <div class="close" @click="$bvModal.hide('modal-precheckindatacollector')"></div>
    </template>

    <div class="d-block text-center">
      <div class="container">
        <div class="row">
          <p> {{ $t('modal_pre_checkin_data_collector.info_txt') }} </p>
        </div>
      </div>
    </div>

     <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 ml-sm-2 mb-2 mb-sm-0">
            <b-button variant="primary" block @click="ok()">
              {{ $t('modal_pre_checkin_data_collector.btn_next') }}
            </b-button>
          </div>
          <div class="flex-grow-1 order-sm-0 mr-sm-2">
            <b-button variant="light" block @click="cancel()">
              {{ $t('modal_pre_checkin_data_collector.btn_back') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters('checkin', [
      'stepData',
    ]),
  },
  methods: {
    ...mapActions('checkin', [
        'resetStepData'
    ]),
    show() {
      // TODO: if use_iframe, chiama contenuto qui dentro, altrimenti fa redirect
    },

    reset() {
    },

    confirm() {
      window.location = this.stepData.form_url
    }
  }
}
</script>
